import VueSlider from 'vue-slider-component';
import getAssetPath from '$utils/getAssetPath';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		min: {
			required: true,
			type: Number,
		},
		max: {
			required: true,
			type: Number,
		},
		interval: {
			type: Number,
			default: undefined,
		},
	},

	components: { VueSlider },

	mounted() {
	},

	data() {
		return {
			marks: {
				min: `< ${this.getValueByInterval(this.min) + 1}`,
				max: `+ ${this.getValueByInterval(this.max) - 1}`,
			},
			updater: 0,
		};
	},

	computed: {
		value: {
			get() {
				return [this.context.model.min, this.context.model.max]
			},
			set(val) {
				this.context.rootEmit("input", {min: val[0], max: val[1]});
			}
		}
	},

	methods: {
		isMobile() {
			return this.$store.state.isMobile;
		},

		isTablet() {
			return this.$store.state.isTablet;
		},

		getValueByInterval(value) {
			return this.interval ? Math.round(value / this.interval) : value;
		},

		tooltipValue(value) {
			if (value <= this.min) {
				return this.marks.min;
			}
			if (value >= this.max) {
				return this.marks.max;
			}

			return this.getValueByInterval(value);
		},

		getBinAssetPath(value, modifier) {
			return getAssetPath(value, modifier);
		},
	},

	watch: {

	}
};
